import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import type { RootState } from 'reduxStore/reducers';
import { requestProductSalesReportDataAction } from '../actions';
import { ProductSalesReport } from './ProductSalesReport';

const mapStateToProps = (state: RootState) => ({
  reportData: state.salesReport.productSales.reportData,
  displayState: state.salesReport.productSales.displayState,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ requestProductSalesReportDataAction }, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ProductSalesReport);
